/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMapNorth = createReactComponent("outline", "map-north", "IconMapNorth", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 15v-6l4 6v-6", "key": "svg-1" }]]);

export { IconMapNorth as default };
//# sourceMappingURL=IconMapNorth.mjs.map
